import { render, staticRenderFns } from "./CommunityIcon.vue?vue&type=template&id=0580ab8e&"
import script from "./CommunityIcon.vue?vue&type=script&lang=js&"
export * from "./CommunityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports